import { ButtonProps, Button as ButtonMui } from "@mui/material";
import classes from "./styles.module.scss";
import clsx from "clsx";

interface Props extends ButtonProps {
  buttonType?: "primary" | "secondary";
  buttonSize?: "xs" | "sm" | "md" | "lg";
  children: React.ReactNode;
  className?: string;
}

export const Button = ({
  children,
  buttonType = "primary",
  buttonSize = "md",
  disabled = false,
  className,
  ...props
}: Props) => {
  return (
    <ButtonMui
      disabled={disabled}
      className={clsx(
        classes.button,
        {
          [classes[buttonType]]: true,
          [classes[buttonSize]]: true,
          [classes.disabled]: disabled,
        },
        className
      )}
      {...props}
    >
      {children}
    </ButtonMui>
  );
};
